import { isTokenExpired } from "../helpers/TokenHelper";
import createHttpInstance from "./http-common";

class BrandMasterServices {
    private serviceName = "/master";

    async GetBrandMasterByProductId(productTypeId: number, serviceTypeId: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetBrandMasterByProductId/${productTypeId}/${serviceTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async getAllBrands() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(`${this.serviceName}/getBrandMasterList`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetSeriesModelByBrandMasterId(brandMasterId: number, serviceTypeId: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetSeriesModelByBrandMasterId/${brandMasterId}/${serviceTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetAllBrandSeries() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .post(`${this.serviceName}/GetAllBrandSeries`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetSeriesModelByBrandSeriesId(brandSeriesId: number, serviceTypeId: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetSeriesModelByBrandSeriesId/${brandSeriesId}/${serviceTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetAllSeriesModel(serviceTypeId: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(`${this.serviceName}/getSeriesModelList/${serviceTypeId}`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetModelVariantBySeriesModelId(seriesModelId: number, ServiceTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetModelVariantBySeriesModelId/${seriesModelId}/${ServiceTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetAllProductType() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(`${this.serviceName}/GetAllProductType`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetRepairTypesForSeries(seriesId: any, serviceTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetRepairTypesForSeries/${seriesId}/${serviceTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetDocumentTypes() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(`${this.serviceName}/GetDocumentTypes`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetProductCategory() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(`${this.serviceName}/GetProductCategory`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetThresholdCategory() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(`${this.serviceName}/GetThresholdCategory`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetRoles() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetRoles`).catch((err: Error) => {
            throw err?.message;
        });
    }
    async GetOSTypebyGadgetId(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(`${this.serviceName}/GetOsTypebyGadgetId?productTypeId=${data}`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetStateList(serviceTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(`${this.serviceName}/GetStateList?serviceTypeId=${serviceTypeId}`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetDistrictList(serviceTypeId: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(`${this.serviceName}/GetDistrictList?serviceTypeId=${serviceTypeId}`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetCityList(serviceTypeId: number) {
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(`${this.serviceName}/GetCityList?serviceTypeId=${serviceTypeId}`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetCategorybyOSTypeGadgetId(productTypeId: any, osTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetCategorybyOSTypeGadgetId?productTypeId=${productTypeId}&osTypeId=${osTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }
    async GetAllStatusToDisplay(serviceTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetAllStatusToDisplay?serviceTypeId=${serviceTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetAllStatus(serviceTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetAllStatus?serviceTypeId=${serviceTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetAllFailureType(serviceTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetAllFailureType?serviceTypeId=${serviceTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetAllCancellationType(serviceTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetAllCancellationType?serviceTypeId=${serviceTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetPromoCodes() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(`${this.serviceName}/GetReferalCodes`)
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetAreaList(serviceTypeId: any, cityId: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetAreaList?serviceTypeId=${serviceTypeId}&cityId=${cityId}`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetAllBrandMaster(serviceTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetAllBrandMaster?serviceTypeId=${serviceTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetBrandSeriesByBrandMasterId(BrandMasterId: number, serviceTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetBrandSeriesByBrandMasterId/${BrandMasterId}/${serviceTypeId}`
            )
            .catch((err) => {
                throw err.response;
            });
    }

    async GetUTMLinks() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetUtmLinks`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetStatusByEntityType(entityTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetStatusByEntityType/${entityTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetFeedBackStatus() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetFeedBackStatus`).catch((err: Error) => {
            throw err?.message;
        });
    }
    async GetBlog(Id: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .post(
                `Blog/GetBlogDetailByBlogId/${Id}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }
    async getBlogCount() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .post("Blog/GetBlogCount")
            .catch((err: Error) => {
                throw err?.message;
            });
    }

    async GetProductThresholdValue(productTypeId: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon
            .get(
                `${this.serviceName}/GetProductThresholdValue?productTypeId=${productTypeId}`
            )
            .catch((err: Error) => {
                throw err?.message;
            });
    }

}

export default new BrandMasterServices();